import { gql, useMutation } from '@apollo/client';

import type { DeleteDependantMutation, DeleteDependantMutationVariables } from './__generated__/useDeleteDependant.gql';

const DELETE_DEPENDANT = gql`
  mutation DeleteDependant($input: DeleteDependantInput!) {
    deleteDependant(input: $input)
  }
`;

/**
 * Removes an existing `Dependant` row. The backend cascade-deletes the
 * caregiver edge, any partnerships, residences, and vehicles tied to the
 * dependant — so this is the single mutation needed when a slot is dropped
 * from the loved-ones onboarding flow.
 *
 * Returns the deleted id as a bare scalar, which Apollo's normalized cache
 * can't reconcile against the family's `caregiverRelationships` list — so
 * callers must refetch the query that reads them (e.g.
 * `useOnboardingDependants().refetch()`) after a delete. The review step does
 * this once, after its delete/create phases.
 */
export const useDeleteDependant = () => {
  return useMutation<DeleteDependantMutation, DeleteDependantMutationVariables>(DELETE_DEPENDANT);
};
